import {DateRange} from './date-range';
import {PresetDateRange} from './presets';
import {DateRangeType} from './types';

export class InsightsTimePickerDateRange extends DateRange {
  public static get presets(): PresetDateRange[] {
    return [
      PresetDateRange.Today,
      PresetDateRange.Yesterday,
      PresetDateRange.Last96Hours,
      PresetDateRange.Last30Days,
      PresetDateRange.Last24Weeks,
      PresetDateRange.Last12Months,
    ];
  }

  // TODO: this only exists to support feature-flagged presets, fold this into the main `presets` when "date_preset_changes" project feature flag is shipped
  public static get experimentalPresets(): PresetDateRange[] {
    return [
      PresetDateRange.Last1Day,
      PresetDateRange.Last96Hours,
      PresetDateRange.Last30Days,
      PresetDateRange.Last24Weeks,
      PresetDateRange.Last12Months,
    ];
  }

  public canUseRolling(): boolean {
    return [DateRangeType.Between, DateRangeType.On].includes(this.type);
  }
}
